import { RCQuestionTypesEnum } from '../../types/entities/coreEntites/Questions';

export const QUESTION_LABELS: Partial<Record<RCQuestionTypesEnum, string>> = {
	[RCQuestionTypesEnum.PREFERRED_TEAM]: 'Preferred Team',
	[RCQuestionTypesEnum.BIRTH_DATE]: 'Birth Date',
	[RCQuestionTypesEnum.ADDRESS]: 'Address',
	[RCQuestionTypesEnum.EMAIL_ADDRESS]: 'Email Address',
	[RCQuestionTypesEnum.PHONE_NUMBER]: 'Phone Number',
	[RCQuestionTypesEnum.T_SHIRT_SIZE]: 'T-Shirt Size',
	[RCQuestionTypesEnum.CUSTOM_WAIVER]: 'T&C',
	[RCQuestionTypesEnum.WAIVER]: 'Waiver',
};

interface IQuestionLabelSource {
	questionType?: RCQuestionTypesEnum | string | null;
	question?: string | null;
}

/**
 * Returns the display label for a questionnaire question.
 * Built-in question types use clear title-case labels; custom questions keep their stored text.
 */
export function getQuestionDisplayLabel(data: IQuestionLabelSource): string {
	if (data.questionType && data.questionType !== RCQuestionTypesEnum.OTHER) {
		const defaultLabel = QUESTION_LABELS[data.questionType as RCQuestionTypesEnum];
		if (defaultLabel) {
			return defaultLabel;
		}
	}

	return data.question ?? '';
}
